import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
const LOGO_IMG = 'https://cdn.magicpatterns.com/uploads/wasYCs8DibeJzMvCRTngbW/WhatsApp_Image_2026-08-10_at_10.58.30_PM.jpg';
export function Footer() {
  return <footer className="w-full bg-tinta py-12 text-crema/80" data-id="element-39" data-mp="32p5nojgp12qd">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-40" data-mp="36p6d0z5byyc7">
        <div className="flex flex-col items-center gap-6 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-41" data-mp="36ppk1ktg02bg">
          <div className="flex items-center gap-2.5" data-id="element-42" data-mp="3ucxmzw3eezab">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-full bg-crema" data-id="element-43" data-mp="37o56rpk5rbs">
              <img src={LOGO_IMG} alt="Logo Cambio Hormonal" className="h-full w-full object-cover" data-id="element-44" data-mp="3ldu2qoshwdu8" />
            </span>
            <span className="leading-tight" data-id="element-45" data-mp="29y5l8cy0g70t">
              <span className="block font-serif text-lg font-semibold text-crema" data-id="element-46" data-mp="2a1jkhcbdo041">
                Cambio Hormonal
              </span>
              <span className="block text-xs uppercase tracking-[0.2em] text-dorado-light" data-id="element-47" data-mp="3l8qvw2zluhqx">
                El Método del 1%
              </span>
            </span>
          </div>

          <div className="flex flex-col items-center gap-4 sm:items-end" data-id="element-48" data-mp="3v7gg42ez4eac">
            <a href="mailto:hola@vuelveavivir.com" className="inline-flex items-center gap-2 text-sm text-crema/80 transition-colors hover:text-crema focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-49" data-mp="3v5deel4gkwps">
              <MailIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-50" data-mp="33e6nbb9yssq" />
              hola@vuelveavivir.com
            </a>
            <nav aria-label="Redes sociales" className="flex items-center gap-3" data-id="element-51" data-mp="hs1vyzuj26a8">
              <a href="https://www.instagram.com/vuelveavivirr" target="_blank" rel="noopener noreferrer" aria-label="Síguenos en Instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-crema/10 text-crema/80 transition-colors hover:bg-crema/20 hover:text-crema focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40" data-id="element-52" data-mp="qthx0gzgcw1s">
                <InstagramIcon className="h-4 w-4" strokeWidth={1.8} data-id="element-53" data-mp="13siqn065lwfd" />
              </a>
            </nav>
            <nav aria-label="Enlaces legales" className="flex items-center gap-4 text-xs" data-id="element-54" data-mp="18kskuseaxing">
              <a href="#politica-de-privacidad" className="text-crema/65 underline-offset-4 transition-colors hover:text-crema hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-55" data-mp="1cnyqbxtlb5sv">
                Política de privacidad
              </a>
              <a href="#terminos-de-uso" className="text-crema/65 underline-offset-4 transition-colors hover:text-crema hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded" data-id="element-56" data-mp="3obevfn6un298">
                Términos de uso
              </a>
            </nav>
          </div>
        </div>

        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-crema/55" data-id="element-57" data-mp="25n3z2fhjr6vh">
          Este programa tiene fines educativos e informativos de bienestar.
        </p>

        <div className="mt-6 grid max-w-3xl gap-3 text-xs leading-relaxed text-crema/55" data-id="element-58" data-mp="1worybkmyuspb">
          <details id="politica-de-privacidad" className="rounded-lg border border-crema/15 px-4 py-3" data-id="element-59" data-mp="2te9c6mw3rl23">
            <summary className="cursor-pointer font-medium text-crema/80 focus:outline-none" data-id="element-60" data-mp="2pd5vjy68dkzt">
              Política de privacidad
            </summary>
            <p className="mt-3" data-id="element-61" data-mp="2feq7y56ewtv2">
              Los datos que compartas al comprar, acceder o contactar se usarán
              únicamente para gestionar tu acceso, atender tus consultas y
              enviarte información relacionada con el programa.
            </p>
          </details>
          <details id="terminos-de-uso" className="rounded-lg border border-crema/15 px-4 py-3" data-id="element-62" data-mp="2rvzl1938jxrl">
            <summary className="cursor-pointer font-medium text-crema/80 focus:outline-none" data-id="element-63" data-mp="2wn99i6d1sv1w">
              Términos de uso y responsabilidad
            </summary>
            <p className="mt-3" data-id="element-64" data-mp="2ntw78dt3gh35">
              Al usar este programa aceptas que tu participación es voluntaria y
              que eres responsable de las decisiones que tomes sobre tu
              bienestar. Este contenido no reemplaza atención médica ni
              profesional, especialmente ante síntomas persistentes o
              condiciones preexistentes.
            </p>
          </details>
        </div>

        <p className="mt-6 text-xs text-crema/50" data-id="element-65" data-mp="36judqph8u24o">
          © {new Date().getFullYear()} Cambio Hormonal · El Método del 1%.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}